function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1f3642;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u5716\\u5C64_2",
  "data-name": "\\u5716\\u5C64 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M80.94,115.28c41.33-25.56,88.57-47.87,121.81-83.34,17.78-19,51.1-47.11,75.3-22C287.77,20,292.65,35,301.31,46.19c22.47,29,59.75,44.4,87.2,68.42,30.92,27.06,59.29,58,80.31,93.4,0,0,36.57,70.52-64,122.76-21.06,10.94-41.29,29.48-54.06,49.47-5.71,8.95-9.5,17.36-17.55,24.65-25.66,23.23-73.72,29.23-106,19.91-33.17-9.57-65-23.2-96.06-38.14-19.74-9.5-41.27-18-58.47-31.89-36-29-54.95-75.47-64.88-119.33-5.59-24.74-12-54.11-4.18-79C14.47,121.76,54.8,131.42,80.94,115.28Z"
}));

function SvgBackgroundG1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 475.31 429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundG1);
export default __webpack_public_path__ + "static/media/background-g-1.19dbb22b.svg";
export { ForwardRef as ReactComponent };